<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data">
      <template #suffix>
        <b-button class="mr-2" variant="dark" v-auth="`update`" @click="openBatchMergeBillModal()">批次合併帳單</b-button>

        <b-button variant="success" @click="exportOrderDetail()">匯出詳細訂單</b-button>
      </template>
    </bread-crumb>

    <b-tabs v-model="tab.tabIndex" class="mb-4">
      <b-tab
        v-for="(item, index) in tab.items"
        :key="index"
        :title="item.label" />
    </b-tabs>

    <div v-if="tab.tabIndex === 1" class="operate">
      <div class="search">
        <date-picker
          v-model="search.pay_date_S"
          :position="'right'"
          placeholder="繳費日期開始"
        ></date-picker>

        <date-picker
          v-model="search.pay_date_E"
          :position="'right'"
          placeholder="繳費日期結束"
        ></date-picker>
      </div>

      <div class="btn-area">
        <div class="btn-function">
          <b-button variant="danger" @click="resetSearch()">重置</b-button>

          <b-button variant="success" @click="getOrder(1)">搜尋</b-button>
        </div>
      </div>
    </div>

    <tables-page
      :tableData="data.table_data"
      :tableFields="tableFields"
      :pageData="data.page"
      v-on:result="getOrder"
    >
      <template #cell(print)="row">
        <b-button
          variant="primary"
          size="sm"
          @click="billhandle(row.item, 'preview')"
        >
          帳單繳費條碼
        </b-button>

        <!-- <b-button
          variant="info"
          size="sm"
          @click="billhandle(row.item, 'download')"
          v-if="row.item.total_1 !== 0"
        >
          下載帳單
        </b-button> -->
      </template>

      <template #cell(no)="row">
        {{ countNoNum(data.page, row.index) }}
      </template>

      <template #cell(created_at)="row">
        {{ convertRocDate(row.item.created_at) }}
      </template>

      <template #cell(function)="row">
        <b-button
          variant="info"
          size="sm"
          @click="openDetailBillModal(row.item)"
        >
          詳細帳單
        </b-button>

        <b-button
          v-if="tab.tabIndex === 0"
          v-auth="`update`"
          variant="danger"
          size="sm"
          @click="cancelMergeBill(row.item)"
        >
          取消合併帳單
        </b-button>
      </template>
    </tables-page>

    <html-to-pdf
      v-if="status.resetDom"
      ref="htmlToPdf"
      :isIframePreviewPdf="print.isIframePreviewPdf"
      :enableDownload="print.enableDownload"
      :params="print.pdfParams"
      @handlerCompleted="billhandlerCompleted"
      @exportImg="data.previewImg = $event"
    >
      <template slot="pdf-content">
        <bill-payment-barcode-template :data="data.temp_table_data"></bill-payment-barcode-template>
      </template>
    </html-to-pdf>

    <!-- 預覽帳單 modal -->
    <preview-bill-modal
      v-model="status.previewBillModal"
      :img="data.previewImg" />

    <!-- 詳細帳單 modal -->
    <detail-bill-modal
      v-model="status.detailBillModal"
      :data="data.bill_data" />

    <!-- 批次合併帳單 modal -->
    <batch-merge-bill-modal
      ref="batch_merge_bill_modal"
      v-model="status.batchMergeBillModal"
      @sumit="batchMergeBill" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import orderApi from "@/models/API/orderApi";
import { countNoNum, convertRocDate, downloadFile } from "@/models/HELPERS/common.js";
import HtmlToPdf from '@/components/common/HtmlToPdf';
import BillPaymentBarcodeTemplate from '@/components/common/PrintTemplate/BillPaymentBarcode';
import PreviewBillModal from "@/components/common/Modal/PreviewBillModal";
import DetailBillModal from "@/components/common/Modal/DetailBillModal";
import datePicker from '@/components/common/DatePicker';
import BatchMergeBillModal from"./components/modal/BatchMergeBillModal";

export default {
  name: 'mergeBill',
  components: {
    BreadCrumb,
    TablesPage,
    HtmlToPdf,
    PreviewBillModal,
    DetailBillModal,
    BillPaymentBarcodeTemplate,
    datePicker,
    BatchMergeBillModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '帳單管理', url: '', isActive: true },
          { name: '合併帳單', url: '', isActive: false }
        ]
      },
      search: {
        pay_date_S: '',
        pay_date_E: '',
      },
      status: {
        resetDom: false,
        previewBillModal: false,
        detailBillModal: false,
        batchMergeBillModal: false
      },
      data: {
        table_data: [],
        page: {},
        temp_table_data: {},
        previewImg: '',
        billMode: '',
        bill_data: []
      },
      tab: {
        items: [
          {
            label: '未繳',
            value: 0
          },
          {
            label: '已繳',
            value: 1
          },
          {
            label: '取消',
            value: 2
          },
        ],
        tabIndex: 0
      },
      print: {
        filename: '',
        enableDownload: false,
        isIframePreviewPdf: false,
        pdfParams: {
          format: 'a5',
          orientation: 'p'
        }
      },
    }
  },
  watch: {
    'tab.tabIndex': {
      handler(newValue, oldValue) {
        this.getOrder();
      },
      immediate: false
    }
  },
  computed: {
    tableFields() {
      let table_fields = [
        {
          key: "no",
          label: "No",
        },
        {
          key: "member_count",
          label: "合併筆數",
        },
        {
          key: "total_M",
          label: "月費",
        },
        {
          key: "total_Y",
          label: "平台年費"
        },
         {
          key: "total_F",
          label: "手續費"
        },
        {
          key: "total_S",
          label: "回饋金"
        },
        {
          key: "total_B",
          label: "墊繳手續費"
        },
        {
          key: "created_at",
          label: "合併日期"
        },
        {
          key: "total",
          label: "合併訂單總金額"
        },
        {
          key: "function",
          label: "功能"
        }
      ]

      if (this.tab.tabIndex === 0) {
        table_fields.unshift(
          {
            key: "print",
            label: "列印"
          }
        )
      }

      return table_fields;
    }
  },
  mounted() {
    this.orderApi = new orderApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.orderApi.page);

      this.getOrder();
    },
    countNoNum,
    convertRocDate,
    // 查詢訂單
    getOrder(pageIndex = null) {
      const params = {
        ...this.search,
        'status': this.statusConversion(),
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.orderApi.getOrder((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數

        this.data.table_data = res.data;
      }, params)
    },
    // 狀態換算
    statusConversion() {
      switch(this.tab.tabIndex) {
        case 0:
          return 1;
        case 1:
          return 0;
        case 2:
          return 2;
      }
    },
    // 帳單處理(下載 OR 預覽)
    async billhandle(item = null, type = 'download') {
      this.data.billMode = type;
      this.status.resetDom = true;
      this.data.temp_table_data = Object.assign({}, item);

      if (type === 'download') this.print.enableDownload = true;
      else if (type === 'preview') this.print.enableDownload = false;

      await this.$nextTick(); // 等待當前更新週期結束

      this.$refs.htmlToPdf.generatePdf();
    },
    // 帳單處理完成
    billhandlerCompleted() {
      this.$set(this.status, 'resetDom', false);
      this.$forceUpdate();

      if (this.data.billMode === 'preview') this.status.previewBillModal = true;
    },
    // 取消合併帳單
    cancelMergeBill(item) {
      const r = confirm(`確定取消合併帳單？`);

      if (r) {
        const params = {
          id: item.id,
          status : 2
        };

        this.orderApi.updateOrder((response) => {
          const res = response.data;
          let result = {};

          if (res.code === 0) {
            result = { message: '取消合併成功', title: '合併帳單' };

            this.getOrder();
          } else {
            result = { message: '取消合併失敗', title: '合併帳單' };
          }

          this.orderApi.toast(() => {}, result, res.code === 0);
        }, params)

        return true;
      }
      return false;
    },
    // 開啟詳細帳單 modal
    openDetailBillModal(item) {
      this.status.detailBillModal = true;
      this.data.bill_data = item.details;
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        pay_date_S: '',
        pay_date_E: '',
      }

      this.getOrder(1);
    },
    // 批次合併帳單modal
    openBatchMergeBillModal() {
      this.status.batchMergeBillModal = true;
    },
    // 批次合併帳單
    batchMergeBill(data) {
      const selected_data = data.filter(item => item.checkbox);
      const r = confirm(`確定合併帳單(${selected_data.map(item => item.number).join(',')})？`);

      if (r) {
        const params = {
          member_id_arr: selected_data.map(item => item.id).join(',')
        };

        this.orderApi.addOrder((response) => {
          const res = response.data;
          let result = {};

          if (res.code === 0) {
            result = { message: '合併成功', title: '合併帳單' };

            this.status.batchMergeBillModal = false;
            this.$refs.batch_merge_bill_modal.resetSearchCondition();
            this.getOrder();
          } else {
            result = { message: '合併失敗', title: '合併帳單' };
          }

          this.orderApi.toast(() => {}, result, res.code === 0);
        }, params)

        return true;
      }
      return false;
    },
    // 匯出詳細訂單EXCEL
    exportOrderDetail() {
      const params = {
        'pay_date_S': this.tab.tabIndex === 1 ? this.search.pay_date_S : '',
        'pay_date_E': this.tab.tabIndex === 1 ? this.search.pay_date_E : '',
        'status': this.statusConversion(),
      }

      this.orderApi.exportOrderDetail((response) => {
        if (!response) return;

        downloadFile(response);
      }, params)
    }
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/mergeBill.vue